export const screenScale = {
  tablet: 1.5,
  laptop: 1.8,
  desktop: 2.0,
};
